import * as types from './constants';

const initialState = {
  data: {},
  editLoading: false,
  errors_api: {}
};

const actions = {
  // Update Regularusers Group
  [types.UPDATE_REGULARUSERS_GROUP_REQUEST]: state => {
    const data = {
      ...state,
      editLoading: true
    };

    return { ...data };
  },

  [types.UPDATE_REGULARUSERS_GROUP_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      editLoading: false,
      data: payload
    };

    return { ...data };
  },

  [types.UPDATE_REGULARUSERS_GROUP_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      editLoading: false,
      errors_api: payload
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

